import { render, staticRenderFns } from "./KnAuthorizationGradeItem.vue?vue&type=template&id=5239e482"
import script from "./KnAuthorizationGradeItem.js?vue&type=script&lang=js&external"
export * from "./KnAuthorizationGradeItem.js?vue&type=script&lang=js&external"
import style0 from "./KnAuthorizationGradeItem.vue?vue&type=style&index=0&id=5239e482&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports